import React from 'react';
import { MOBILE_BATTLE_DOCK_LIFT_PX } from './mobileBattleLayoutOffsets';

function opponentBlackMarketMaxUses(gameState, opponentId) {
  if (opponentId != null && (opponentId === 'bot' || String(opponentId).includes('bot'))) {
    return 1;
  }
  const n = Number(gameState?.exploreUnknownBlackMarketUsesPerBattle);
  return Number.isFinite(n) && n > 0 ? n : 1;
}

/**
 * Mobile Opponent Preparation Bonus and Diplomatic Accord Component
 * Positioned to the left of opponent drone zone
 */
export const MobileOpponentBonuses = ({
  gameState,
  userId,
  opponentPreparationBonus,
  opponentDiplomaticAccord,
  t
}) => {
  const currentOpponentId = gameState?.players?.find(id => id !== userId);
  const currentOpponent = currentOpponentId ? gameState?.state?.[currentOpponentId] : null;
  const opponentGoesSecond = currentOpponentId && gameState?.players?.[1] === currentOpponentId;
  const shouldShowPrepBonus = opponentGoesSecond && 
                     opponentPreparationBonus && 
                     (opponentPreparationBonus === 'plan_ahead' || opponentPreparationBonus === 'black_market' || opponentPreparationBonus === 'team_leader');
  const blackMarketMaxUses = opponentPreparationBonus === 'black_market'
    ? opponentBlackMarketMaxUses(gameState, currentOpponentId)
    : 1;
  const blackMarketUses = Number(currentOpponent?.blackMarketUsesThisBattle) || 0;
  const blackMarketChargesRemaining = Math.max(0, blackMarketMaxUses - blackMarketUses);
  const prepExhausted =
    opponentPreparationBonus === 'black_market'
      ? blackMarketChargesRemaining <= 0
      : currentOpponent?.preparationBonusUsed === true;
  const prepTooltip =
    prepExhausted
      ? (t('battleUI.preparationBonusUsed') || 'Preparation bonus already used')
      : opponentPreparationBonus === 'plan_ahead'
        ? t('profile.preparationBonus.planAhead')
        : opponentPreparationBonus === 'black_market'
          ? blackMarketMaxUses >= 2
            ? t('profile.preparationBonus.blackMarketDossierTwoCharges', {
                remaining: blackMarketChargesRemaining,
                total: blackMarketMaxUses,
              })
            : t('profile.preparationBonus.blackMarketDossier')
          : t('profile.preparationBonus.teamLeaderMeeting');
  
  if (!shouldShowPrepBonus && !opponentDiplomaticAccord) return null;
  
  return (
    <div
      className="opponent-bonuses-mobile"
      style={{
        position: "absolute",
        top: `${5 + MOBILE_BATTLE_DOCK_LIFT_PX}px`,
        right: "125px",
        zIndex: 1002,
        display: "flex",
        gap: "2px",
        flexDirection: "row",
        transform: "scale(0.35)",
        transformOrigin: "top right"
      }}
    >
      {/* Opponent Preparation Bonus */}
      {shouldShowPrepBonus && currentOpponent && (
        <div 
          style={{ 
            width: "84px",
            height: "84px"
          }}
          data-tooltip={prepTooltip}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              margin: 0,
              ...(prepExhausted ? {
                filter: 'grayscale(100%)',
                background: 'rgba(30, 30, 30, 0.7)',
                opacity: 0.7
              } : {
                background: 'rgba(50, 50, 50, 0.5)',
                filter: 'none',
                opacity: 1
              })
            }}
          >
            <img 
              src={`/images/${opponentPreparationBonus === 'plan_ahead' ? 'plan_ahead.jpg' : 
                            opponentPreparationBonus === 'black_market' ? 'black_market_dossier.jpg' : 
                            'team_leader_briefing.jpg'}`}
              alt={opponentPreparationBonus}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                pointerEvents: "none"
              }}
            />
          </div>
        </div>
      )}
      
      {/* Opponent Diplomatic Accord */}
      {opponentDiplomaticAccord && (
        <div 
          style={{ 
            width: "84px",
            height: "84px"
          }}
          data-tooltip={
            opponentDiplomaticAccord === 'strategic_coordination' ? t('profile.diplomaticAccords.strategicCoordination') :
            opponentDiplomaticAccord === 'public_relations' ? t('profile.diplomaticAccords.publicRelations') :
            opponentDiplomaticAccord === 'emergency_protocol' ? t('profile.diplomaticAccords.emergencyProtocol') :
            t('profile.diplomaticAccords.commandDirective')
          }
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              margin: 0,
              background: 'rgba(50, 50, 50, 0.5)'
            }}
          >
            <img 
              src={`/images/${opponentDiplomaticAccord === 'strategic_coordination' ? 'strategic_coordination.jpg' : 
                            opponentDiplomaticAccord === 'public_relations' ? 'public_relations.jpg' : 
                            opponentDiplomaticAccord === 'emergency_protocol' ? 'emergency_protocol.jpg' : 
                            'command_directive.jpg'}`}
              alt={opponentDiplomaticAccord}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                pointerEvents: "none"
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileOpponentBonuses;
